import React from "react";
import moment from "moment";
import { Tooltip, IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import CustomTableFooter from "../../../../utils/CustomTableFooter";
import { getStudents } from "../../../../crud/api/students.crud";

export const getColumns = ({
  is_admin,
  openDialog,
  staff_member_admin,
  deleteStudents,
}) => [
  {
    name: "user",
    label: "Picture",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) =>
        value &&
        (value.avatar || value.avatar_thumb) && (
          <div
            style={{
              background: `url(${
                value.avatar_thumb ? value.avatar_thumb : value.avatar
              }) center center / cover no-repeat`,
              height: 40,
              width: 40,
              borderRadius: "50%",
              margin: "-5px 0",
            }}
          />
        ),
    },
  },
  {
    name: "user",
    label: "Name",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) =>
        value && (
          <>
            {value.first_name} {value.last_name}
          </>
        ),
    },
  },
  {
    name: "user",
    label: "Email",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => value && <>{value.email}</>,
    },
  },
  {
    name: "birthday",
    label: "Birthday",
    options: {
      display: is_admin,
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return value ? (
          <span>{moment(value).format("MMM DD YYYY")}</span>
        ) : (
          <span>-</span>
        );
      },
    },
  },
  {
    name: "created_at",
    label: "Date Registered",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) =>
        value && <>{moment(value).format("MMM DD YYYY")}</>,
    },
  },
  {
    name: "team",
    label: "Team",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) =>
        value && <>{value && value !== null ? value.name : ""}</>,
    },
  },
  {
    name: "user",
    label: "User Status",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return (
          value && (
            <>{value !== null ? (value.active ? "Active" : "Inactive") : ""}</>
          )
        );
      },
    },
  },
  {
    name: "gender",
    label: "Gender",
    options: {
      display: is_admin,
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return value ? <span>{value}</span> : <span>-</span>;
      },
    },
  },
  {
    name: "id",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value, meta) =>
        value && (
          <div className="d-flex">
            <Tooltip title="Edit Athlete" placement="top">
              <IconButton
                id={`edit_student_btn_${value}`}
                size="small"
                onClick={() => openDialog("editing", value)}
                aria-label="Edit Athlete"
              >
                <i className="fas fa-edit text-primary" />
              </IconButton>
            </Tooltip>
            {(staff_member_admin || is_admin) && (
              <Tooltip title="Delete Athlete" placement="top">
                <IconButton
                  id={`delete_student_btn_${value}`}
                  size="small"
                  className="mx-3"
                  onClick={() => deleteStudents(value)}
                  aria-label="Delete Athlete"
                >
                  <Delete color="error" />
                </IconButton>
              </Tooltip>
            )}
          </div>
        ),
    },
  },
];

export const getOptions = ({
  isDesktop,
  settingLoader,
  students,
  studentActions,
  school,
  query,
  getQueryGroup,
  setRowsSelected,
}) => {
  return {
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectableRowsOnClick: true,
    onRowsSelect: (currentRowsSelected, allRowsSelected) => {
      const selectedData = allRowsSelected.map(
        (r) => students.data[r.dataIndex]
      );

      setRowsSelected(selectedData.map((s) => s.id));
    },
    customToolbarSelect: () => null,
    serverSide: true,
    rowsPerPageOptions: [],
    rowsPerPage: students.rowsPerPage,
    page: students.page,
    count: students.count,
    rowHover: false,
    search: false,
    sort: false,
    print: false,
    filter: false,
    viewColumns: false,
    download: false,
    tableBodyMaxHeight: isDesktop ? "50em" : "357px",
    textLabels: {
      body: {
        noMatch: "No data",
      },
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: "Rows=",
        displayRows: "of",
      },
    },
    downloadOptions: {
      filename: "Athlete.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayRowsOnly: true,
      },
    },
    customFooter: (count, page, rowsPerPage) => (
      <CustomTableFooter
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onChangePage={(mPage) => {
          settingLoader(true);
          getStudents(
            studentActions.setStudents,
            school.slug,
            mPage,
            query,
            getQueryGroup()
          )
            .catch((error) => {
              console.error("Failed to fetch students:", error);
            })
            .finally(() => settingLoader(false));
        }}
      />
    ),
  };
};
